import { render, staticRenderFns } from "./KBKLimitSelectorPopup.view.vue?vue&type=template&id=27e65542&"
import script from "./KBKLimitSelectorPopup.view.vue?vue&type=script&lang=js&"
export * from "./KBKLimitSelectorPopup.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27e65542')) {
      api.createRecord('27e65542', component.options)
    } else {
      api.reload('27e65542', component.options)
    }
    module.hot.accept("./KBKLimitSelectorPopup.view.vue?vue&type=template&id=27e65542&", function () {
      api.rerender('27e65542', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/overlays/popups/dictionaries/limits/KBKLimitSelectorPopup.view.vue"
export default component.exports